import SbsPlayerLogger from '../../utils/logger';
import { SbsPlayerGlobal } from '../../common';

class OnairFlag {
  constructor() {
    this.url = null;
    this.interval = null;

    this.sendInterval = null;
    this._event = {
      initialized: () => {
        console.log(`initialized.`);
      },
      passed: (result) => {
        console.log(`passed. ${JSON.stringify(result)}`);
      },
      failed: (message) => {
        console.log(`failed. ${message}`);
      },
      errored: () => {
        console.log(`errored.`);
      },
    };
  }

  get event() {
    return this._event;
  }
  set event(event) {
    this._event = event;
  }

  init() {
    this._event.initialized();
  }

  send() {
    try {
      console.log('온에어플래그 전송 인터벌', this.url);

      let { info } = SbsPlayerGlobal.state.data;
      this.interval = info.flag_repeat_time;

      this.sendInterval = setInterval(() => {
        let { info } = SbsPlayerGlobal.state.data;
        this.url = info.flag_url;

        let fetchOptions = {};
        if (document.cookie === '') {
          fetchOptions = {
            method: 'GET',
          };
        } else {
          fetchOptions = {
            method: 'GET',
            credentials: 'include',
          };
        }

        fetch(this.url, fetchOptions)
          .then((response) => {
            if (response.status === 200) {
              response.json().then((result) => {
                if (result.onair_yn === 'N') {
                  this._event.failed(result.onair_text);
                } else if (result.overseas_yn === 'N') {
                  this._event.failed(result.overseas_text);
                } else {
                  this.interval = result.flag_repeat_time;
                  if (result.cmdata) {
                    SbsPlayerGlobal.state.data.ad_30.cmdata.category =
                      result.cmdata.category;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.programid =
                      result.cmdata.programid;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.clipid =
                      result.cmdata.clipid;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.contentnumber =
                      result.cmdata.contentnumber;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.targetnation =
                      result.cmdata.targetnation;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.isonair =
                      result.cmdata.isonair;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.ispay =
                      result.cmdata.ispay;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.vodtype =
                      result.cmdata.vodtype;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.broaddate =
                      result.cmdata.broaddate;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.playtime =
                      result.cmdata.playtime;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.starttime =
                      result.cmdata.starttime;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.endtime =
                      result.cmdata.endtime;
                    SbsPlayerGlobal.state.data.ad_30.cmdata.slots =
                      result.cmdata.slots;

                    SbsPlayerGlobal.state.data.ad_31.cmdata.category =
                      result.cmdata.category;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.programid =
                      result.cmdata.programid;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.clipid =
                      result.cmdata.clipid;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.contentnumber =
                      result.cmdata.contentnumber;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.targetnation =
                      result.cmdata.targetnation;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.isonair =
                      result.cmdata.isonair;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.ispay =
                      result.cmdata.ispay;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.vodtype =
                      result.cmdata.vodtype;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.broaddate =
                      result.cmdata.broaddate;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.playtime =
                      result.cmdata.playtime;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.starttime =
                      result.cmdata.starttime;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.endtime =
                      result.cmdata.endtime;
                    SbsPlayerGlobal.state.data.ad_31.cmdata.slots =
                      result.cmdata.slots;
                    console.log('### flag 광고규격 갱신');
                  }
                  this._event.passed(result);
                }
              });
            } else {
              this._event.errored();
            }
          })
          .catch(function (err) {
            console.error(err);
            this._event.errored();
          });
      }, this.interval * 1_000);
    } catch (error) {
      console.log(error);
    }
  }

  clear() {
    try {
      clearInterval(this.sendInterval);
      this.sendInterval = null;
    } catch (error) {
      console.log(error);
    }
  }
}

export default OnairFlag;
